import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=303673ca&"
import script from "./Welcome.vue?vue&type=script&lang=ts&"
export * from "./Welcome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports